// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".Logo-module__logo___1Hw19 {\n  pointer-events: none;\n  width: 150px;\n}\n\n@media (min-width: 768px) {\n  .Logo-module__logo___1Hw19 {\n    width: 300px;\n  }\n}", "",{"version":3,"sources":["Logo.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF","file":"Logo.module.css","sourcesContent":[".logo {\n  pointer-events: none;\n  width: 150px;\n}\n\n@media (min-width: 768px) {\n  .logo {\n    width: 300px;\n  }\n}"]}]);
// Exports
exports.locals = {
	"logo": "Logo-module__logo___1Hw19"
};
module.exports = exports;
